export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5176.3ffa0ca6.jpg";